import React, { ReactNode } from 'react';
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';
import { useRootStore } from 'core/hooks/use-root-store';
import { CandidateRegisterStore } from './candidate-register.store';

const CandidateRegisterContext = React.createContext<CandidateRegisterStore | null>(null);

export const CandidateRegisterProvider = ({ children }: { children: ReactNode }) => {
   const rootStore = useRootStore();
   const { i18n, t } = useTranslation('global');

   const selectedLanguage = Cookies.get('selectedLanguage') || i18n.language || 'ukr';
   const apiLanguage = selectedLanguage === 'ukr' ? 'uk' : selectedLanguage;

   const [store] = React.useState<CandidateRegisterStore>(
      () => new CandidateRegisterStore(rootStore, t, apiLanguage)
   );

   return (
      <CandidateRegisterContext.Provider value={store}>
         {children}
      </CandidateRegisterContext.Provider>
   );
};

export const useCandidateRegister = (): CandidateRegisterStore => {
   const ctx = React.useContext(CandidateRegisterContext);
   if (!ctx) {
      throw new Error('useCandidateRegister must be used inside CandidateRegisterProvider');
   }
   return ctx;
};
